import { redirect } from 'vike/abort';

// TEMPORARY: the default /archive landing currently sends visitors to the
// NFL+CFB-since-2020 verified-results view instead of the "All Results" summary
// cards. Delete this file to restore the summary page — its component is left
// intact in +Page.tsx on purpose.
const VERIFIED_RESULTS = '/archive/nfl,cfb?startDate=20200701' as const;

export function guard(pageContext: Vike.PageContext) {
  // Only redirect the bare /archive index. The nested results pages
  // (e.g. /archive/nfl,cfb) inherit this guard, so without the path check we
  // would redirect them too and loop forever.
  const path = pageContext.urlPathname.replace(/\/$/, '');
  if (path === '/archive') {
    throw redirect(VERIFIED_RESULTS);
  }
}
